module.exports = __webpack_public_path__ + "static/assets/b631383707e87a454b479dedaa8ca014.svg";